import axios from '@/utils/request'
export function PromoteGeneralReg(data) {
  return axios({
    url: '/user/player_register',
    method: 'post',
    data
  })
}
export function PromotePhoneReg(data) {
  return axios({
    url: '/user/player_phone_register',
    method: 'post',
    data
  })
}
export function yzm(data) {
  return axios({
    url: '/user/yzm',
    method: 'post',
    data
  })
}
//法大大用户认证
export function getAuthUrl(data) {
  return axios({
    url: '/contract/getAuthUrl',
    method: 'post',
    data
  })
}
//法大大合同签署链接
export function createSignContract(data) {
  return axios({
    url: '/contract/createSignContract',
    method: 'post',
    data
  })
}

//检查冰火盒子注册页是否可注册
export function check_register_page(data) {
  return axios({
    url: '/user/check_register_page',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js